module.exports = __webpack_public_path__ + "static/banca-9436e353cb2c8fd11371914de2cc706c.png";